import { render } from "./BlogWordpress.vue?vue&type=template&id=28ac81ee&scoped=true"
import script from "./BlogWordpress.vue?vue&type=script&lang=js"
export * from "./BlogWordpress.vue?vue&type=script&lang=js"

import "./BlogWordpress.vue?vue&type=style&index=0&id=28ac81ee&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28ac81ee"]])

export default __exports__